<template>
  <div class="sc-vehicle-outer-container">
    <div class="sc-vehicle-reg-header">
      <h1 class="page-title"><b>{{ $t('vehicle_registration.vehicle_registration') }}</b></h1>
    </div>
    <div class="sc-vehicle-reg-cart-info">
      {{ $t('vehicle_registration.more_vehicles_to_register', { number: unFilledVehicleDetailsLeft() }) }}
    </div>
    <div>
      <sc-registered-vehicle-list
        v-if="showVehicleList"
        v-on:[SelectedVehicleDetailsIndex]="catchVehicleDetailsId($event)"/>
      <register-vehicles-input
        v-else
        :vehicleDetails="vehicleDetails"
        @closeForm="catchInputClose"
        @save="catchInputSave($event)"/>
    </div>
  </div>
</template>

<script>
import ScRegisteredVehicleList from '@/order-wizard/components/registervehicles/RegisteredVehicleList'
import RegisterVehiclesInput from '@/order-wizard/components/registervehicles/RegisterVehiclesInput.vue'
import { VehicleRegisterAction } from '@/order-wizard/utils/VehicleRegisterAction'

export default {
  name: 'RegisterVehicles',
  components: {
    ScRegisteredVehicleList,
    RegisterVehiclesInput
  },
  data () {
    return {
      SelectedVehicleDetailsIndex: VehicleRegisterAction.SelectedVehicleDetailsIndex,
      showVehicleList: true,
      vehicleDetails: null
    }
  },
  methods: {
    catchVehicleDetailsId (id) {
      this.vehicleDetails = this.$store.getters.getVehiclesInCart().find(v => v.id === id)
      this.showVehicleList = false
      window.scrollTo(0, 0)
    },
    catchInputClose () {
      this.showVehicleList = true
    },
    catchInputSave (event) {
      this.showVehicleList = true
    },
    unFilledVehicleDetailsLeft () {
      return this.$store.getters.numberOfUnfilledVehiclesInCart()
    }
  }
}
</script>

<style lang="scss" scoped>
.sc-vehicle-outer-container {
  width: 50%;
  margin: auto;
}
.sc-vehicle-reg-cart-info {
  text-align: left;
  font-size: 18px;
  font-weight: 600;
}

@media(max-width: 768px) {
  .sc-vehicle-outer-container{
    width: 100%;
  }
  .sc-vehicle-outer-container .page-title{
    margin: 15px 0px;
  }
}
</style>
